import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  getAllCategories: queryParams => {
    return httpApi.getDataViaApi({
      url:api.product.getAllCategories,
      queryParams
    })
  },
  getAllProducts: queryParams => {
    return httpApi.getDataViaApi({
      url: api.product.getAllProducts,
      queryParams
    })
  },
  getProductDetails: queryParams => {
    return httpApi.getDataViaApi({
      url: api.product.getProductDetails,
      queryParams
    })
  }
}